interface StructuredDataProps {
  data: Record<string, any> | Array<Record<string, any>>;
}

export function StructuredData({ data }: StructuredDataProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

// Global Organization & LocalBusiness Schema
export const businessSchema = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'TravelAgency'],
  '@id': 'https://skivatours.com/#organization',
  name: 'Skiva Africa Tours',
  url: 'https://skivatours.com',
  logo: 'https://skivatours.com/logo.png',
  image: 'https://skivatours.com/about-hero.png',
  slogan: 'Luxury in Motion, Africa in Sight',
  telephone: '+27785870868',
  email: 'rushncube@support.skivatours.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '5482 Sene St. Protea Glen, Ext 20',
    addressLocality: 'Johannesburg',
    addressCountry: 'ZA',
  },
  areaServed: [
    {
      '@type': 'AdministrativeArea',
      name: 'Johannesburg',
    },
    {
      '@type': 'AdministrativeArea',
      name: 'Gauteng',
    },
    {
      '@type': 'Country',
      name: 'South Africa',
    },
  ],
  makesOffer: [
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Airport transfers',
        description: 'Reliable private airport transfer services between OR Tambo International Airport and Johannesburg, Pretoria and surrounding destinations.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Private transport',
        description: 'Professional private vehicle transportation across Johannesburg and South Africa.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Corporate transportation',
        description: 'Executive corporate travel, business meeting movements, events and VIP client transfers.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Shuttle services',
        description: 'Dependable shuttle transfer services tailored for corporate teams and delegations.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Group transportation',
        description: 'Group transport solutions for corporate teams, events, conferences and private groups.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Tours / tourism experiences',
        description: 'Guided private tours and luxury safari tourism experiences in South Africa.',
      },
    },
  ],
};

// WebSite Schema
export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'https://skivatours.com/#website',
  url: 'https://skivatours.com',
  name: 'Skiva Africa Tours',
  publisher: {
    '@id': 'https://skivatours.com/#organization',
  },
};

// BreadcrumbList Schema Generator
export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
